import { Card, CardBody, CardHeader, Collapse, Input } from "reactstrap";
import { Href, PrivacyTitle } from "../../../../../../Constants/Constants";
import { PrivacyData } from "../../../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";

const Privacy = () => {
  const { account } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "2" ? "2" : ""))}>
        <a href={Href}>{PrivacyTitle}<i className={`fa fa-angle-${account === "2" ? "up" : "down"}`} /></a>
      </CardHeader>
      <Collapse className={`${account === "2" ? "show" : ""}`}>
        <CardBody>
          <ul className="privacy">
            {PrivacyData.map((item, index) => (
              <li key={index}>
                <span>{item.title}</span>
                <div className="media-right form-switch">
                  <Input type="checkbox" defaultChecked={item.checked} />
                </div>
                {item.text && (<p><b>Note : </b>{item.text}</p>)}
              </li>
            ))}
          </ul>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default Privacy;
